import { Controller } from "@hotwired/stimulus"

// Recarrega un Turbo Frame quan canvia un select (p. ex. producte → varietats).
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  reload(event) {
    this.frameTarget.src = this.urlValue.replace(":id", encodeURIComponent(event.target.value))
  }
}
